import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./verified-modal.module.scss";
import Modal from "../../../../../shared/modal/modal";
import Button from "../../../../ui-kit/button/button";
import successIco from "../../../../../images/success-icon.svg";
import deniedIco from "../../../../../images/denied-icon.svg";

const VerifiedModal = ({
  verified,
  setVerifiedModal,
  modalMessage,
  modalTitle,
  onResetChanges: onResetChangesProp,
}: {
  verified: boolean;
  setVerifiedModal: (arg: null) => void;
  modalMessage: string;
  modalTitle: string;
  onResetChanges: () => void;
}) => {
  const { t } = useTranslation("translation");
  const onResetChanges = () => {
    onResetChangesProp();
    setVerifiedModal(null);
  };

  return (
    <Modal
      onClose={() => setVerifiedModal(null)}
      closeClass={styles.closeButton}
      className={styles.modalWrapper}
    >
      <div className={styles.verifiedModal}>
        <h2>{modalTitle}</h2>
        <img
          src={verified ? successIco : deniedIco}
          alt={
            verified
              ? t("verified-modal.successAlt")
              : t("verified-modal.rejectAlt")
          }
        />
        <div className={styles.desc}>
          <h2>{modalMessage}</h2>
          {!verified && <span>{t("verified-modal.messages.correctData")}</span>}
        </div>
        <div className={styles.buttons}>
          {verified ? (
            <>
              <Button
                className={styles.confirm}
                onClick={() => setVerifiedModal(null)}
              >
                {t("verified-modal.buttons.confirm")}
              </Button>
            </>
          ) : (
            <>
              <Button
                className={styles.makeEdits}
                onClick={() => setVerifiedModal(null)}
              >
                {t("verified-modal.buttons.makeEdits")}
              </Button>
              <Button
                className={styles.resetChanges}
                type="outline"
                onClick={onResetChanges}
              >
                {t("verified-modal.buttons.resetChanges")}
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default VerifiedModal;
